function displayElement(element, state, values, globalState) {
  // don't show if element has hidden properties
  if (element.hidden) {
    return false;
  }

  if (globalState && element.displayIfFromGlobalState) {
    return element.displayIfFromGlobalState(globalState, state);
  }

  // don't show if element has either a displayIfFromValues or a displayIfFromState function and it returns false
  // on either one. displayIfFromValues checks the element against values set in the current page values
  // while displayIfFromState checks the element against values set in the state
  return (
    (!element.displayIfFromValues ||
      element.displayIfFromValues(values)) &&
    (!element.displayIfFromState || element.displayIfFromState(state))
  );
}

export { displayElement };
